import React from "react";
import BuyerListItem from "../../components/buyer/BuyerList/BuyerListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const BuyerListPage = ()  => {

    useTitle(t`List Buyer`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <BuyerListItem showAdd={true} {...query} />
        </Box>
    )
}

export default BuyerListPage;
